import { Box, Button, FormControlLabel, Radio, RadioGroup, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { computeScale } from "../../../constants/utils";
import { GameContext, IGameContext } from "../../../contexts/GameContext";
import AnimationPlayer from "../Results/AnimationPlayer";
import ComfortBar from "../Results/ComfortBar";
import QualityBar from "../Results/QualityBar";
import { computeFinalAvg, computeFinalCumulAvg, computeFinalScore } from "../../../interface/Util";
import { AppContext } from "../../../contexts/AppContext";
import { setStyle } from "../../../util";
import FinalScore from "../End/FinalScore";
import { GameState } from "../../../interface/GameState";
import { EquationsService } from "../../../services/equations/equationService";


const Thankyou = () => {
  const { beginTime,maxPoints, finalScores, values, results, points, interfaceParams, bounds, maxRound,setStartAt, setData, setScores, setPoints, setTime, setResults, setGameState, setCurrentStep, setRound,setFinalScores, setGameId } = useContext<IGameContext>(GameContext);

  const { defaultValues, jwtToken, connectSocket } = useContext(AppContext);

  useEffect(() => {
      if (defaultValues) setStyle(defaultValues);
  })

  async function handleReplay(){
    if(jwtToken){
      const configResponse = await EquationsService.getGameConfigFile(jwtToken);
      if (configResponse.status === 200){
        const gameConfig = configResponse.data;
        setData(gameConfig.default[0]);
      }
    }
    setFinalScores([])
    setCurrentStep(0);
    setResults([{ "timestamps": [], "score": 0 }])
    setTime(beginTime[0]);
    setPoints(maxPoints[0]);
    setScores([[]])
    setRound(0);
    setStartAt(new Date())
    setGameId(crypto.randomUUID())
    await connectSocket()
    
    setGameState(GameState.ROUND)
    
  }
  
  return (
    <Container className="wrapper-resultat final-results">
      <Box className="wrapper-top-panel">
        <Box className="container-top">
          <Box className="container-top-left">
            <Typography sx={{ m: 4, fontWeight: 'bold' }} variant="h5">Résultats du jeu</Typography>
          </Box>
          <Box className="container-top-right">
            <Box className="box-result">
              <Box className="container-result">
               <FinalScore finalScore={computeFinalScore(finalScores)} scores={finalScores} />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Body className="container-resultat">

        <MainWindow className="main-resultat">
          <Typography>Vous pouvez rejouer au jeu !</Typography>
          <Typography>Cependant, la carte cadeau est choisie uniquement lors de votre première complétion du jeu. Rejouer n’offre pas la possibilité de changer de carte ni d’en cumuler plusieurs. Amusez-vous bien !</Typography>
        </MainWindow>

        <Stack className="container-analysis">
          {/*
          <Analysis values={values} points={points} finalScores={finalScores} />
          */}
          <Button variant="contained" onClick={()=>{handleReplay()}} >Rejouer</Button>
        </Stack>

      </Body>
    </Container>
  );
};


const Container = styled.div`
`;


const Body = styled.div`
    display: flex;
`


const MainWindow = styled.div`
`;

const Title = styled.div`
    display: flex;
    color: white;
    padding: .5em;
`;

const Row = styled.div`
    display: flex;
`;

const StatBox = styled.div`
    
`;


export default Thankyou;